module.exports = __webpack_public_path__ + "bg.69a31c3c1214fb967a6c.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/liyankai/Documents/github/seiya_web.git/src/assets/images/bg.jpg
// module id = ../../../../../src/assets/images/bg.jpg
// module chunks = styles